"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>SignOutActions
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_TravelBotLogoImage_js_namespaceObject = require("../../TravelBotLogoImage.js");
const MessageFooter_js_namespaceObject = require("../MessageFooter/MessageFooter.js");
var MessageFooter_js_default = /*#__PURE__*/ __webpack_require__.n(MessageFooter_js_namespaceObject);
const sanitizeInput_js_namespaceObject = require("../../utils/sanitizeInput.js");
var sanitizeInput_js_default = /*#__PURE__*/ __webpack_require__.n(sanitizeInput_js_namespaceObject);
const useChatMessagesContext_js_namespaceObject = require("../../hooks/useChatMessagesContext.js");
const FindMyTrips_js_namespaceObject = require("../FindMyTrips/FindMyTrips.js");
var FindMyTrips_js_default = /*#__PURE__*/ __webpack_require__.n(FindMyTrips_js_namespaceObject);
const OtpContext_js_namespaceObject = require("../../context/OtpContext.js");
const getLastUserMessage_js_namespaceObject = require("../../utils/getLastUserMessage.js");
const SignOutActions_SignOutActions = ({ submitMessagesFn, showOtpForm, displayHardCodedMessage = true })=>{
    const { chatMessages } = (0, useChatMessagesContext_js_namespaceObject.useChatMessagesContext)();
    const [showTripForm, setShowTripForm] = (0, external_react_namespaceObject.useState)(false);
    const messageEndRef = (0, external_react_namespaceObject.useRef)(null);
    const lastuserQuestion = (0, getLastUserMessage_js_namespaceObject.getLastUserMessageContent)(chatMessages);
    const encodedLastUserQuestion = `?openPenny=y${encodeURIComponent('&')}askPrompt=${sanitizeInput_js_default()(lastuserQuestion)}`;
    const currentPathName = 'undefined' != typeof window ? window.location.pathname : '/';
    const signOutActionButtons = [
        {
            name: 'Sign In',
            link: ()=>{
                window.location.href = `/home/join?flow=authenticate&redirecturl=${currentPathName}${encodedLastUserQuestion}`;
            }
        },
        {
            name: 'Find My Trip',
            link: ()=>{
                window.open('/next-profile/trip-lookup');
            }
        }
    ];
    function handleOtpSubmit(token) {
        submitMessagesFn({
            role: 'assistant',
            content: 'User is trying to access their bookings'
        }, null, {
            'account-less-access-token': token
        });
    }
    (0, external_react_namespaceObject.useEffect)(()=>{
        messageEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, [
        showOtpForm,
        showTripForm
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                        mb: 4,
                        flexDirection: "column",
                        children: [
                            displayHardCodedMessage && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessage, {
                                ml: "",
                                mb: "20px",
                                variation: 'initial',
                                Icon: external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage,
                                message: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                            mb: 3,
                                            children: "To access your trips, please sign in to your account. Alternatively we can find your trip by providing us some details."
                                        }),
                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                            children: "To safeguard your privacy, this chat will be cleared upon signing in."
                                        })
                                    ]
                                }),
                                footer: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MessageFooter_js_default(), {})
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                                ml: 3,
                                mt: 4,
                                children: signOutActionButtons.map((actionBtns)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                                        mr: 2,
                                        onClick: function() {
                                            if ('Find My Trip' === actionBtns.name && showOtpForm) setShowTripForm(true);
                                            else actionBtns.link();
                                        },
                                        variation: "subtle",
                                        children: actionBtns.name
                                    }, actionBtns.name))
                            })
                        ]
                    }),
                    showTripForm ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(OtpContext_js_namespaceObject.OtpContextProvider, {
                            handleOtpSubmit: handleOtpSubmit,
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(FindMyTrips_js_default(), {})
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                ref: messageEndRef
            })
        ]
    });
};
const SignOutActions = SignOutActions_SignOutActions;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
